module.exports = __webpack_public_path__ + "static/autostoreMeta-4333938caed3e2340ae6c7d0717f0ea5.jpg";